import { getThemeColor } from '../../app.theme';

export default class PrintService {
  constructor($http, appConfig, $window) {
    "ngInject";

    this.$http = $http;
    this.appConfig = appConfig;
    this.$window = $window;
  }

  printReport(reportName, criteria) {
    criteria.additionalParameter1 = getThemeColor('--report-even-row');
    criteria.additionalParameter2 = getThemeColor('--report-even-hover');
    
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/report/${reportName}`, JSON.stringify(criteria));
  }

  printVehicleList(queryParams) {
    this.$window.open(this.appConfig.apiServiceBaseUri + `api/print/vehiclelist/${queryParams}`);
  }

  printDpaHistory(contactId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/dpahistory/${contactId}`);
  }

  printSimiOrderForm(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/simiorderform/${enquiryId}`);
  }  

  printSignedOrderForm(enquiryId, entityId, authCode) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/signedoderform/${enquiryId}`, JSON.stringify({entityId, authCode}));
  }  
  
  printSimiTradeOrderForm(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/simitradeorderform/${enquiryId}`);
  }    

  nonSimiOrderForm(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/nonSimiOrder/${enquiryId}`);
  }

  printQuotation(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/quotation/${enquiryId}`);
  }

  saveQuotation(enquiryId, userId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/print/form/savequotation/${enquiryId}/${userId}`);
  }  
  
  emailQuotation(enquiryId, userId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/print/form/emailquotation/${enquiryId}/${userId}`);
  } 

  printTradeOrderForm(enquiryId, isSimi) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/tradeorderform/${enquiryId}/${isSimi}`);
  }

  printFinanceQuotation(enquiryId, selectedOption) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/financequotation/${enquiryId}/${selectedOption}`);
  }

  printVehicleAppraisal(appraisalId, enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/appraisal/${appraisalId}/${enquiryId}`);
  }

  printMSL_DNS_CustomForm(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_msl_dns/${enquiryId}`);
  }    

  printMercUsedWarranty_CustomForm(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_mercusedwarranty/${enquiryId}`);
  }    

  printMercSPA_CustomForm(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_mercspa/${enquiryId}`);
  }      

  printMercUsedSPA_CustomForm(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_mercusedspa/${enquiryId}`);
  }  
  
  printMercDPA_CustomForm(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_mercdpa/${enquiryId}`);
  }    

  printMslUsedDPA_CustomForm(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_msluseddpa/${enquiryId}`);
  }   
  
  printMazdaDPA_CustomForm(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_mazdadpa/${enquiryId}`);
  }     

  printSkodaDPA_CustomForm(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_skodadpa/${enquiryId}`);
  }     

  printRf105Form_CustomForm(enquiryId) {
      this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_rf105form/${enquiryId}`);
  }

  printRf105TradeForm_CustomForm(enquiryId) {
      this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_rf105tradeform/${enquiryId}`);
  }

  printMslBydDpa_CustomForm(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_mslbyddpa/${enquiryId}`);
  }  

  printOrderConfirmation_Customer(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_orderconfirmation/${enquiryId}`);
  }

  printCunninghamOrderForm_CustomForm(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_cunninghamorderform/${enquiryId}`);
  }    

  printDistanceSellingAddendum_CustomForm(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_distancesellingaddendum/${enquiryId}`);
  }

  printOrderFormGuid_CustomForm(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_orderformguide/${enquiryId}`);
  }  

  printMSL_PCP_CustomForm(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_msl_pcp/${enquiryId}`);
  }    

  printMslPreOwnedWarrantyAgreement(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_mslusedwarranty/${enquiryId}`);
  }    

  printMslXpengDpa_CustomForm(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_mslxpengdpa/${enquiryId}`);
  }    

  printSuzukiDataForm_CustomForm(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_suzukidataform/${enquiryId}`);
  }   
  
  paymentReceipt(enquiryId, userId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/paymentreceipt/${enquiryId}/${userId}`);
  }   
  
  printLyonsPrepWorkForm_CustomForm(enquiryId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/cf_lyonsprepworkform/${enquiryId}`);
  }     

  printInvoice(invoiceId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/invoice/print/${invoiceId}`);
  }  
  
  printInvoicePaymentReceipt(invoiceId) {
    this.formPrint(this.appConfig.apiServiceBaseUri + `api/print/form/invoicepaymentreceipt/${invoiceId}`);
  }  

  emailInvoice(entityId, invoiceId, cc) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/print/form/emailinvoice/${entityId}/${invoiceId}/${cc}`);
  }         
  
  serialize(obj) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        if (Array.isArray(obj[p])){
          obj[p].map(item => {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(item));
          })          
        }
        else{
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
        
      }
    return str.join("&");
  }

  formPrint(url, postData) {
    const frm = $('#frmPrint');
    frm.attr('action', url);    
    $('#postdata').val(postData);
    frm.submit();        
  }
}



// WEBPACK FOOTER //
// ./client/app/common/services/print.service.js